import { ArrowRightRegular, LockClosedRegular } from '@fluentui/react-icons';
import './AccessDenied.css';

export function AccessDenied() {
  return (
    <div className="access-denied-page">
      <main className="access-denied" aria-labelledby="access-denied-title">
        <section className="access-denied-card">
          <div className="access-denied-icon" aria-hidden="true">
            <LockClosedRegular />
          </div>
          <span className="access-denied-badge">Phased rollout</span>
          <h1 id="access-denied-title">GovernanceHub V2 isn't available to you yet</h1>
          <p className="access-denied-intro">
            We're rolling out the new portal in stages. Your account isn't part of the current
            rollout ring, so you don't have access to V2 yet.
          </p>
          <section className="access-denied-guidance" aria-labelledby="access-denied-guidance-title">
            <h2 id="access-denied-guidance-title">Keep working in your current portals</h2>
            <p>
              You don't need to take any action to join a ring. Continue managing your requests,
              apps, agents, and digital assets in the current portals until your group is included.
            </p>
            <div className="access-denied-actions">
              <a
                className="access-denied-primary"
                href="https://governancehub.microsoft.com/"
              >
                Go to current GovernanceHub
                <ArrowRightRegular aria-hidden="true" />
              </a>
              <a
                className="access-denied-secondary"
                href="https://alm.microsoft.com/"
              >
                Go to current ALM
                <ArrowRightRegular aria-hidden="true" />
              </a>
            </div>
          </section>
          <section className="access-denied-details" aria-labelledby="access-denied-details-title">
            <h2 id="access-denied-details-title">When will I get access?</h2>
            <p>
              Access will be enabled when your group is included in a deployed ring. Follow the
              rollout notifications/communications from the existing portals for availability
              and next steps.
            </p>
          </section>
        </section>
      </main>
    </div>
  );
}
